import Row from './row';
import './list.scss';

const ListTable = ({ stratigraphyLexicons, updateStratigraphyLexicon, addStratigraphyLexicon, deleteAddingRow, deleteStratigraphyLexicon, allStratigraphyLexicons }:any) => {
    return (                          
        <table className="table">
            <thead>
                <tr>                    
                    <th>Description</th>
                    <th>Alternative</th>
                    <th>Color</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {(stratigraphyLexicons || []).map((lexicon: any, index: number) => (
                <Row key={lexicon.id} 
                     lexicon={lexicon} 
                     updateStratigraphyLexicon={updateStratigraphyLexicon} 
                     addStratigraphyLexicon={addStratigraphyLexicon} 
                     deleteAddingRow={deleteAddingRow}
                     deleteStratigraphyLexicon={deleteStratigraphyLexicon}
                     allStratigraphyLexicons={allStratigraphyLexicons} />
            ))}
            </tbody>
        </table>                              
    )    
};

export default ListTable;